import {CurrencyFormatter} from 'platform/locale';

import {valueOrPlaceholder} from 'shared/web';

/**
 * Formats a plain amount for read-only display. An amount the currency formatter rejects is
 * shown as a dash instead of an empty space.
 */
export function formatCurrencyOrDash(
  formatCurrency: CurrencyFormatter,
  amount: number,
  currency: string
) {
  return valueOrPlaceholder(formatCurrency(amount, currency));
}
